import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const ServiceAreas = () => {
  const [areas, setAreas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/service-areas`)
      .then(res => {
        setAreas(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error:', err);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <section className="bg-gradient-to-r from-blue-600 to-green-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Our Service Areas</h1>
          <p className="text-xl max-w-3xl mx-auto">Professional pest control throughout NYC and surrounding areas</p>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          {loading ? (
            <div className="text-center py-12 text-xl">Loading service areas...</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {areas.map(area => (
                <Link 
                  key={area.id} 
                  to={`/service-areas/${area.slug}`}
                  className="bg-white rounded-lg shadow-lg p-6 hover:shadow-2xl transition"
                >
                  <div className="text-5xl mb-4">📍</div>
                  <h2 className="text-2xl font-bold mb-3">{area.name}</h2>
                  <p className="text-gray-600 mb-4">{area.description.substring(0, 120)}...</p>
                  {area.neighborhoods && area.neighborhoods.length > 0 && (
                    <div className="mb-4">
                      <p className="text-sm font-semibold text-gray-500 mb-2">Neighborhoods:</p>
                      <p className="text-sm text-gray-600">{area.neighborhoods.slice(0, 3).join(', ')}...</p>
                    </div>
                  )}
                  <span className="text-blue-600 font-semibold">View Details →</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="py-16 bg-blue-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Serving All of NYC & Long Island</h2>
          <p className="text-xl text-gray-700 mb-8">Fast, reliable pest control service in your area. Call us now!</p>
          <a href="tel:6462099955" className="bg-green-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-green-700 transition inline-block">Call (646) 209-9955</a>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreas;